import { Action } from '@reduxjs/toolkit'

type ActionProperties = {
  itemToAddOnCreation?: {
    itemId: string
    itemType: GQL_Searchable
    source: string
  }
  actionToReplayOnClose?: Action
}

type OpenAction = ActionProperties & {
  type: 'OPEN_CREATE_NEW_BUCKET_LIST'
}

type CloseAction = {
  type: 'CLOSE_CREATE_NEW_BUCKET_LIST'
}

export type CreateNewBucketListAction = OpenAction | CloseAction

export const openCreateNewBucketList = ({
  itemToAddOnCreation,
  actionToReplayOnClose,
}: ActionProperties): OpenAction => {
  return {
    type: 'OPEN_CREATE_NEW_BUCKET_LIST',
    itemToAddOnCreation,
    actionToReplayOnClose,
  }
}

export const closeCreateNewBucketList = (): CloseAction => {
  return {
    type: 'CLOSE_CREATE_NEW_BUCKET_LIST',
  }
}
